<template>
    <pre class="mt-15">
      <code v-html="formattedHtml" class="html"></code>
    </pre>
  </template>
  
  <script>
  export default {
    props: {
      htmlContent: String, // HTML content to be displayed
    },
    computed: {
      formattedHtml() {
        // Replace HTML entities with their actual characters for better display
        const formatted = this.htmlContent.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return formatted;
      },
    },
  };
  </script>
  
  <style scoped>
  /* Styles for the code block */
  pre {
    background-color: #f7f7f7;
    padding: 10px;
    border-radius: 5px;
    overflow-x: auto;
  }
  
  code.html {
    display: block;
    white-space: pre-wrap;
    font-family: 'Courier New', Courier, monospace;
  }
  </style>